import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ValidationError extends EluveError {
  static override readonly errorName = 'ValidationError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Validation failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
